import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const PaymentGTM = props => {

    const location  = useLocation();

    let queryParams = location.search?.split("#")[0];
    
    const status = queryParams.split("status=")[1]?.split("&")[0]; 
    const userName = queryParams.split("username=")[1]?.split("&")[0]; 
    const userId = useSelector(state => state.UserData?.userData?.id);
    const price = props.price;

    useEffect(()=>{
        
        if((status === "0" || status === "1") && price && (userId||userName)){
            window.dataLayer = window.dataLayer || []; 
            window.dataLayer.push({ 
            'event': 'user_id_available',
            'user_payment': price, 
            'user_id': userId || userName 
            });
        }

    },[price, userId , userName, status]);

    return(
        <span />
    )
}

export default PaymentGTM;